import { neo4jVersionUtil } from '@nx/neo4j-version-utils';

export function versionSupportsCypher25(
  neo4jVersion: string,
  cypher25Enabled: boolean,
  cypherVersions?: string[],
): boolean {
  return cypher25Enabled
    ? neo4jVersionUtil.compareLoose(neo4jVersion, '5.26.0') >= 0
    : cypherVersions?.includes('25') === true;
}
